import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiLocationQueryResponse,
  GetApiLocation401,
  GetApiLocation403,
} from "../../../types/GetApiLocation";

export function getGetApiLocationUrl() {
  return `/api/Location` as const;
}

/**
 * {@link /api/Location}
 */
export async function getApiLocation(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiLocationQueryResponse,
    ResponseErrorConfig<GetApiLocation401 | GetApiLocation403>,
    unknown
  >({
    method: "GET",
    url: getGetApiLocationUrl().toString(),
    ...requestConfig,
  });
  return res;
}
